"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const title_svg_1 = __importDefault(require("../../../assets/svg/title.svg"));
const TitleWrapper = styled_components_1.default.div `
    position: relative;
    height: auto;
`;
const StyledSvg = (0, styled_components_1.default)(title_svg_1.default) `
    width: 100%;
    height: auto;
`;
const TextOverlay = styled_components_1.default.span `
    position: absolute;
    top: 37%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: ${(props) => props.hasSmallText ? "1.8rem" : '2rem'};
    font-weight: bold;
    color: white;
    text-align: center;
`;
const Title = ({ text, hasSmallText = false }) => (react_1.default.createElement(TitleWrapper, null,
    react_1.default.createElement(StyledSvg, null),
    react_1.default.createElement(TextOverlay, { hasSmallText: hasSmallText }, text)));
exports.default = Title;
